import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './PlaceHolder.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  value: string;
};

const PlaceHolder = ({ i18n: { translate }, value }: Props) => (
  <div className={cls('PlaceHolder')}>
    <span className={cls('PlaceHolder__destination')}>{value}</span>
    <span>
      &nbsp;
      {translate('SearchControls_label_enterHotelOrLandmark')}
    </span>
  </div>
);

export default withI18n(PlaceHolder);
